import { Item } from '@react-stately/collections'
import { Selection } from '@react-types/shared'
import emoji from 'node-emoji'
import { setMeta } from 'proseShared/utils/transactions'
import { type EditorView } from 'prosemirror-view'
import { Key } from 'react'
import Styles from './EmojiPlugin.module.scss'
import { List } from './List'
import { EMOJI_PLUGIN_KEY } from './constants'

interface Props {
  /**
   * The editor view. This is used by the list to attach its keyboard handlers to the view dom
   */
  view: EditorView
  /**
   * The text of the emoji
   */
  query: string
  /**
   * Called when the user selects a suggestion via either keyboard or pointer
   */
  onSelect: (key: string) => void
}

export const Suggestions = ({ view, query, onSelect }: Props) => {
  const pluginState = EMOJI_PLUGIN_KEY.getState(view.state)
  const results = emoji.search(query)

  if (!pluginState?.active) {
    return null
  }

  if (results.length === 0) {
    setMeta(EMOJI_PLUGIN_KEY, { noResults: true })(view.state, view.dispatch)
    return null
  }

  const handleSelect = (keys: Selection) => {
    const key = (keys as Set<Key>).values().next().value
    if (typeof key !== 'string') {
      return
    }
    const selectedEmoji = emoji.get(key)
    if (typeof selectedEmoji === 'string') {
      onSelect(selectedEmoji)
    }
  }

  return (
    <div className={Styles.dropdown}>
      <List view={view} items={results} onSelectionChange={handleSelect}>
        {results.map((item) => (
          <Item textValue={item.key} key={item.key}>
            <span className={Styles.emoji}>{item.emoji}</span>
            <span className={Styles.title}>:{item.key}:</span>
          </Item>
        ))}
      </List>
    </div>
  )
}
